module.exports = __webpack_public_path__ + "img/triangle.cb6aac8e.svg";